document.querySelectorAll('.b7-product-tab').forEach(tabSection => {
  const tabs = tabSection.querySelectorAll('[data-tab-index]');
  const panels = tabSection.querySelectorAll('[data-tab-panel]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const index = tab.dataset.tabIndex;

      tabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
        t.closest('.b7-tab__item')?.classList.remove('active');
      });

      panels.forEach(panel => {
        panel.classList.remove('active');
        panel.hidden = true;
      });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      tab.closest('.b7-tab__item')?.classList.add('active');

      const activePanel = tabSection.querySelector(`[data-tab-panel="${index}"]`);
      if (activePanel) {
        activePanel.classList.add('active');
        activePanel.hidden = false;
      }
    });
  });
});


document.querySelectorAll('.b7-product-tab').forEach(tabSection => {
  const accordion = tabSection.querySelectorAll('.b7-product-tab__accordion');

  // 첫 번째 기본 오픈
  if (accordion.length > 0) {
    const firstItem = accordion[0];
    const firstContent = firstItem.querySelector('.b7-product-tab__accordion-contents');

    firstItem.classList.add('open');
    firstContent.style.height = firstContent.scrollHeight + 'px';
  }

  accordion.forEach(item => {
    const btn = item.querySelector('.b7-product-tab__accordion-btn');
    const content = item.querySelector('.b7-product-tab__accordion-contents');

    btn.addEventListener('click', function() {

      const isOpen = item.classList.contains('open');

      accordion.forEach(i => {
        i.classList.remove('open');

        const c = i.querySelector('.b7-product-tab__accordion-contents');
        c.style.height = '';
      });

      // 이미 열려있으면 닫기
      if (isOpen) return;

      item.classList.add('open');
      content.style.height = content.scrollHeight + 'px';
    });
  });
});